import { colors, headingType, weights } from '@components/theme/styles/index';
import { Box, Drawer, styled, TextField } from '@mui/material';
import { rem } from 'polished';

export const StyledDrawer = styled(Drawer)(() => ({
  '& .MuiDrawer-paper': {
    width: '100%',
    maxWidth: rem(697),
  },
}));

export const DrawerHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  minHeight: rem(85),
  justifyContent: 'space-between',
  padding: `${rem(8)} ${rem(12)}`,
}));

export const Title = styled('div')(() => ({
  color: colors.grayDark3,
  fontFamily: headingType,
  fontSize: rem(18),
  fontWeight: weights.semiBold,
}));

export const SubTitle = styled('div')(() => ({
  color: colors.grayDark3,
  fontSize: rem(14),
  fontWeight: weights.normal,
}));

export const DrawerContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  height: '100%',
  overflow: 'auto',
  backgroundColor: colors.grayLight3,
  display: 'flex',
  flexDirection: 'column',
}));

export const DrawerRequestBox = styled(Box)(() => ({
  width: '100%',
}));

export const StyledRequestItem = styled('div')(() => ({
  display: 'flex',
  border: `1px solid ${colors.grayLight1}`,
  background: colors.white,
  padding: `${rem(4)} ${rem(10)}`,
  height: rem(50),
  alignItems: 'center',
  justifyContent: 'space-between',
  color: colors.grayDark3,
  transition: 'all 0.2s ease',
  '&:hover': {
    background: colors.grayLight2,
  },
  '[data-dragging="true"]': {
    opacity: 0.5,
    background: colors.grayLight3,
  },
}));

export const RequestTitle = styled('span')(() => ({
  fontWeight: weights.medium,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  fontSize: rem(14),
  width: rem(300),
}));
export const CheckboxContainer = styled('div')(() => ({
  width: rem(36),
}));

export const StyledDiv = styled('div')<{ $opaque: boolean; mt: number }>(
  ({ $opaque, mt }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: `${rem(mt)}`,
    ...($opaque && {
      opacity: 0.5,
      pointerEvents: 'none',
      userSelect: 'none',
    }),
  }),
);

export const DrawerFooter = styled(Box)({
  padding: rem(12),
  backgroundColor: colors.white,
  display: 'flex',
  justifyContent: 'space-between',
  position: 'sticky',
  bottom: 0,
  zIndex: 1,
});

export const GroupContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
});

export const UngroupBox = GroupContainer;

export const GroupHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: `1px solid ${colors.grayLight1}`,
  padding: `${rem(4)} ${rem(10)} ${rem(4)} ${rem(20)}`,
});

export const GroupName = styled(Box)({
  flex: 2,
});

export const StyleTextField = styled(TextField)({
  backgroundColor: colors.white,
});

export const ActionButtons = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flex: 1,
  gap: rem(25),
});

export const DragHandle = styled('div')({
  cursor: 'grab',
  display: 'flex',
  alignItems: 'center',
  touchAction: 'none',
});

export const GroupContent = styled('div')({
  border: `1px solid ${colors.grayLight1}`,
  background: colors.grayLight2,
  padding: `${rem(20)} ${rem(20)}`,
});
